import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 1. 초기 세션 확인
    const initSession = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user ?? null);
      setLoading(false);
    };

    initSession();

    // 2. 인증 상태 변경 리스너 (로그인/로그아웃 실시간 감지)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  // 유저 로그인/로그아웃 메서드까지 컨텍스트에 포함
  const login = () => supabase.auth.signInWithOAuth({ provider: 'google' });
  const logout = () => supabase.auth.signOut();

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {!loading && children} {/* 세션 확인이 끝나기 전엔 자식 컴포넌트를 렌더링하지 않음 */}
    </AuthContext.Provider>
  );
};

// 다른 컴포넌트에서 쉽게 꺼내 쓰기 위한 커스텀 훅
export const useAuth = () => useContext(AuthContext);